import React from 'react'
import { Link, useNavigate } from 'react-router-dom';

// project imports
import { useProductContext } from '../../../context/product_context';
import { GoogleAnalyticsEnum, triggerFunction } from '../../../utils/google-analytics';
import ErrorComponent from '../../error-message/ErrorComponent';
import { FREE, PAID } from '../../../constants';
import EBookWidgetStencil from './EBookWidgetStencil';

function EBookWidget({ classes, props, currentEBook }) {
    // Extracting variables from context
    const { ebooks, productsError, productLoading, } = useProductContext();

    const navigate = useNavigate();

    // Constant variable
    const paid = ebooks?.filter((item) => item?.pricing.price > 0) || [];
    // const data = paid && paid?.length ? paid : [];
    const data = paid.filter(
        (item) => item?.productCode !== currentEBook?.productCode
    );
    // Data sorting
    const sortedData = [...data].sort(
        (a, b) =>
            new Date(b.metadata?.createdAt) - new Date(a.metadata?.createdAt)
    );
    // Handle function for navigate ebook to detail page
    const handleNavigateDetail = (data) => {
        try {
            navigate(
                `/our-resources/${paid ? PAID : FREE}/${data?.productCode?.toLowerCase()}`
            );
            triggerFunction(
                GoogleAnalyticsEnum.BUTTON,
                GoogleAnalyticsEnum.LSA_SALESFORCE_RESOURCE_DETAIL_VIEWED
            );
        } catch (error) {
            console.log(
                "32 : EBookWidget : Error in handleOpenDrawer : ",
                error && JSON.stringify(error)
            );
        }
    };

    if (productLoading) {
        return <EBookWidgetStencil classes={classes} />;
    }

    return (
        <>
            <div className={`edu-blog-widget widget-instagram p-4 ${classes ? classes : ''}`}>
                <div className="inner">
                    <div class="d-flex justify-content-between align-items-center pb-3 border-bottom-1">
                        <h2 class="fs-17 fw-500 mb-0">E-Book You May Like</h2>
                        <a
                            class="fs-14 color-primary text-decoration-underline"
                            rel="noreferrer"
                            href="/our-resources/paid"
                        >
                            View All
                        </a>
                    </div>
                    <div>
                        {!productLoading && productsError ?
                            <div className="row g-5 mt--10 text-center">
                                <ErrorComponent errorCode="500" mainError={`No ebooks are available!`} subText={`Currently no ebooks are available. Please be back later.`} buttonText="Back to Home" link='/' />
                            </div>
                            :
                            (!productLoading && !productsError && data && !data.length) ?
                                // <ErrorComponent errorCode="404" mainError="Oops...! No Courses are available." />
                                <ErrorComponent errorCode="404" mainError={`Failed to get ebooks right now.`} subText="Please return to the site's homepage, It looks like nothing was found at this location" buttonText="Back to Home" link='/' />
                                :
                                <div className="content mt--20">
                                    <div className="instagram-list">
                                        {(sortedData || [])?.slice(0, 6).map((elm, i) => (

                                            <a className="clickable" onClick={() => handleNavigateDetail(elm)} key={i}>
                                                <img src={`${process.env.PUBLIC_URL}/images/ebooks/${elm?.media?.thumbnailUrl}`} alt={elm?.name} />
                                            </a>

                                        ))}
                                    </div>
                                </div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default EBookWidget;
